
import {
  LOAD_HB_INDEX_ERROR,
  LOAD_HB_INDEX_SUCCESS,
  LOAD_PRIMARY_EMOTIONS_BREAKDOWN_ERROR,
  LOAD_PRIMARY_EMOTIONS_BREAKDOWN_REQUEST, LOAD_PRIMARY_EMOTIONS_BREAKDOWN_SUCCESS, LOAD_RESPONSES_INFO_ERROR,
  LOAD_RESPONSES_INFO_SUCCESS,
  LOAD_SENTIMENT_BREAKDOWN_ERROR,
  LOAD_SENTIMENT_BREAKDOWN_REQUEST, LOAD_SENTIMENT_BREAKDOWN_SUCCESS, LOAD_TOP_WORDS_ERROR, LOAD_TOP_WORDS_REQUEST,
  LOAD_TOP_WORDS_SUCCESS
} from "./charts-action-types";

export const loadTopWordsRequest = reportUrl => ({ type: LOAD_TOP_WORDS_REQUEST, reportUrl });
export const loadTopWordsSuccess = (topWords) => (
  { type: LOAD_TOP_WORDS_SUCCESS, topWords }
  );
export const loadTopWordsError = error => ({ type: LOAD_TOP_WORDS_ERROR, error });

export const loadSentimentBreakdownRequest = reportUrl => ({ type: LOAD_SENTIMENT_BREAKDOWN_REQUEST, reportUrl });
export const loadSentimentBreakdownSuccess = sentimentBreakdown => (
  { type: LOAD_SENTIMENT_BREAKDOWN_SUCCESS, sentimentBreakdown}
  );
export const loadSentimentBreakdownError = error => ({ type: LOAD_SENTIMENT_BREAKDOWN_ERROR, error});
export const loadPrimaryEmotionsBreakdownRequest = reportUrl => ({ type: LOAD_PRIMARY_EMOTIONS_BREAKDOWN_REQUEST, reportUrl });
export const loadPrimaryEmotionsBreakdownSuccess = primaryEmotionsBreakdown => (
  { type: LOAD_PRIMARY_EMOTIONS_BREAKDOWN_SUCCESS, primaryEmotionsBreakdown }
  );
export const loadPrimaryEmotionsBreakdownError = error => ({ type: LOAD_PRIMARY_EMOTIONS_BREAKDOWN_ERROR, error });

export const loadResponsesInfoSuccess = responsesInfo => ({ type: LOAD_RESPONSES_INFO_SUCCESS, responsesInfo });
export const loadResponsesInfoError = error => ({ type: LOAD_RESPONSES_INFO_ERROR, error });

export const loadHbIndexSuccess = hbIndex => ({ type: LOAD_HB_INDEX_SUCCESS, hbIndex});
export const loadHbIndexError = error => ({ type: LOAD_HB_INDEX_ERROR, error });


// WEBPACK FOOTER //
// ./src/modules/charts/charts-action-creators.js